import Route from '@ember/routing/route';
import type Transition from '@ember/routing/transition';
import { service } from '@ember/service';
import type LocationOverviewHrisNotificationsController from 'garaje/pods/location-overview/hris-dashboard/notifications/controller';
import type { NotificationsModel } from 'garaje/pods/location-overview/hris-dashboard/notifications/controller';
import type AjaxFetchService from 'garaje/services/ajax-fetch';
import type StateService from 'garaje/services/state';
import urlBuilder from 'garaje/utils/url-builder';

export default class HrisDashboardNotificationsRoute extends Route {
  @service declare ajaxFetch: AjaxFetchService;
  @service declare state: StateService;

  controllerName = 'location-overview/hris-dashboard/notifications';
  templateName = 'location-overview/hris-dashboard/notifications';

  async model(): Promise<NotificationsModel> {
    try {
      return await this.ajaxFetch.request(
        urlBuilder.hrisLifecycle.url(`/notifications?company_id=${this.state.currentCompany.id}`),
      );
    } catch (err) {
      // Don't crash the tab if settings can't be loaded (authz / transient error) —
      // setupFromModel falls back to DEFAULT_STATE when `notifications` is absent.
      // eslint-disable-next-line no-console
      console.error('[hris-notifications] failed to load notification settings:', err);
      return {};
    }
  }

  // This route reuses the location-overview controller (controllerName above) but,
  // unlike that route, must call setupFromModel() itself — otherwise the fetched
  // settings are ignored and the company-wide tab renders DEFAULT_STATE.
  setupController(
    controller: LocationOverviewHrisNotificationsController,
    model: NotificationsModel,
    transition: Transition<unknown>,
  ): void {
    super.setupController(controller, model, transition);
    controller.setupFromModel();
  }
}
